<mat-list-item class="ignored-drivers-list-item">
  <img id="ignoredDriversListItem-image-avatar-{{ driver.id }}" matListItemIcon class="avatar" [dotsDriver]="dotsDriver" />
  <h4 id="ignoredDriversListItem-text-name-{{ driver.id }}" matListItemTitle data-private>{{ driver.firstName }} {{ driver.lastName }}</h4>
  <div matListItemMeta>
    <button mat-stroked-button color="warn" (click)="deleteIgnoredDriver($event)">
      <mat-icon>remove_circle</mat-icon>
      <span id="ignoredDriversListItem-button-remove-{{ driver.id }}">&nbsp;Remove {{ driver.firstName }}</span>
    </button>
  </div>
</mat-list-item>
